<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <!-- LIST -->
  <ng-container *ngIf="viewMode() === 'list'">
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
      <div>
        <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
          <span class="w-11 h-11 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 text-slate-900 inline-flex items-center justify-center shadow-[0_8px_20px_-6px_rgba(251,191,36,0.55)]">
            <span class="material-icons">campaign</span>
          </span>
          ส่งข้อความ LINE OA
        </h1>
        <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
          ส่งรูป แจ้งประกาศในระบบ หรือออกแบบการ์ดข้อความ ทดสอบส่ง แล้วส่งถึงสมาชิกตามกลุ่ม
        </p>
      </div>
      <div class="flex flex-col sm:flex-row sm:items-center gap-3 self-start md:self-end">
        <div class="inline-flex items-center gap-2 h-[46px] pl-3 pr-1.5 rounded-2xl bg-white/95 dark:bg-slate-800/95 border border-slate-100/50 dark:border-slate-700 shadow-sm">
          <div class="flex flex-col justify-center min-w-[7.5rem] pr-1 border-r border-slate-100 dark:border-slate-700">
            <span class="text-[10px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
            <span class="text-[13px] font-bold leading-none tabular-nums text-slate-600 dark:text-slate-300">
              {{ lastFetchedTime() ? (lastFetchedTime() | date:'HH:mm:ss') : '--:--:--' }}
            </span>
          </div>
          <button type="button" (click)="reload()" [disabled]="isLoading() || isSaving()" title="โหลดข้อมูลใหม่"
            class="w-9 h-9 rounded-xl text-slate-500 hover:text-amber-500 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-all flex items-center justify-center disabled:opacity-40 cursor-pointer border-none bg-transparent">
            <span class="material-icons text-[20px]" [class.animate-spin]="isLoading()">refresh</span>
          </button>
        </div>
        <button *ngIf="canCreate" type="button" (click)="openCreate()"
          class="px-5 h-[46px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer border-none">
          <span class="material-icons text-[18px]">add</span>
          สร้างแคมเปญ
        </button>
      </div>
    </div>

    <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden relative">
      <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <div class="flex flex-wrap gap-2">
          <button *ngFor="let f of statusFilters" type="button" (click)="setStatusFilter(f.value)"
            class="px-3 h-9 rounded-xl text-xs font-bold transition-all border cursor-pointer"
            [ngClass]="filterStatus() === f.value
              ? 'bg-amber-400 border-amber-400 text-slate-900 shadow-sm'
              : 'bg-slate-50 dark:bg-slate-900 border-slate-100 dark:border-slate-700 text-slate-500 hover:border-amber-300 hover:text-amber-700'">
            {{ f.label }}
          </button>
        </div>
        <div class="relative w-full lg:w-72">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
          <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()" placeholder="ค้นหาชื่อแคมเปญ / ข้อความ..."
            class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none" />
        </div>
      </div>

      <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
        <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()" [class.pointer-events-none]="isLoading()">
          <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
            <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
              <th class="p-4">แคมเปญ</th>
              <th class="p-4">กลุ่มผู้รับ</th>
              <th class="p-4 text-center">สถานะ</th>
              <th class="p-4 text-right">ผู้รับ</th>
              <th class="p-4 text-right">สำเร็จ / ล้ม</th>
              <th class="p-4">ส่งเมื่อ</th>
              <th class="p-4 text-center w-[120px]">จัดการ</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
            <tr *ngFor="let item of items(); trackBy: trackById" class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 transition-all">
              <td class="p-4">
                <p class="font-bold text-slate-700 dark:text-slate-200 flex items-center gap-2">
                  {{ item.title || '—' }}
                  <span class="inline-flex items-center gap-0.5 px-2 py-0.5 rounded-full text-[10px] font-bold shrink-0" [ngClass]="messageTypeMeta(item.messageType).className">
                    <span class="material-icons text-[12px]">{{ messageTypeMeta(item.messageType).icon }}</span>
                    {{ messageTypeMeta(item.messageType).label }}
                  </span>
                </p>
                <p class="text-xs text-slate-400 mt-0.5">
                  สร้าง {{ item.createDate ? (item.createDate | date:'dd/MM/yyyy HH:mm') : '—' }}
                  <span *ngIf="item.createdByName">· {{ item.createdByName }}</span>
                </p>
              </td>
              <td class="p-4 font-semibold">{{ audienceLabel(item.audienceType) }}</td>
              <td class="p-4 text-center">
                <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold" [ngClass]="statusMeta(item.status).className">
                  <span class="material-icons text-[14px]" [class.animate-pulse]="item.status === 'sending'">{{ statusMeta(item.status).icon }}</span>
                  {{ statusMeta(item.status).label }}
                </span>
              </td>
              <td class="p-4 text-right tabular-nums font-bold">{{ item.status === 'draft' ? '—' : (item.recipientCount | number) }}</td>
              <td class="p-4 text-right tabular-nums">
                <ng-container *ngIf="item.status !== 'draft'; else dash">
                  <span class="text-emerald-600 font-bold">{{ item.successCount | number }}</span>
                  <span class="text-slate-300 mx-1">/</span>
                  <span [class.text-rose-500]="item.failCount > 0" class="font-bold">{{ item.failCount | number }}</span>
                </ng-container>
                <ng-template #dash>—</ng-template>
              </td>
              <td class="p-4 text-xs">
                {{ item.sentAt ? (item.sentAt | date:'dd/MM/yyyy HH:mm') : '—' }}
                <span *ngIf="item.sentByName" class="block text-slate-400">{{ item.sentByName }}</span>
              </td>
              <td class="p-4 text-center whitespace-nowrap">
                <button type="button" (click)="openItem(item)" [title]="item.status === 'draft' && canUpdate ? 'แก้ไข' : 'ดูรายละเอียด'"
                  class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-amber-400 hover:text-amber-500 transition-all cursor-pointer mr-1 bg-transparent">
                  <span class="material-icons text-base">{{ item.status === 'draft' && canUpdate ? 'edit' : 'visibility' }}</span>
                </button>
                <button *ngIf="canDelete && item.status !== 'sending'" type="button" (click)="askDelete(item)" title="ลบ"
                  class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-rose-400 hover:text-rose-500 transition-all cursor-pointer bg-transparent">
                  <span class="material-icons text-base">delete</span>
                </button>
              </td>
            </tr>
            <tr *ngIf="!isLoading() && items().length === 0">
              <td colspan="7" class="py-20 text-center text-slate-400">
                <span class="material-icons text-4xl mb-2 opacity-40 block">campaign</span>
                <p class="font-bold">ยังไม่มีแคมเปญ</p>
                <p class="text-xs mt-1">กด “สร้างแคมเปญ” เพื่อเริ่มออกแบบข้อความ</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex items-center justify-between gap-4">
        <span class="text-sm text-slate-500 font-medium">ทั้งหมด {{ totalCount() | number }} รายการ</span>
        <div class="flex items-center gap-2">
          <button type="button" (click)="onPageChange(page() - 1)" [disabled]="page() <= 1"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer bg-transparent">
            <span class="material-icons text-sm">chevron_left</span>
          </button>
          <span class="text-sm font-bold tabular-nums px-2">{{ page() }} / {{ totalPages }}</span>
          <button type="button" (click)="onPageChange(page() + 1)" [disabled]="page() >= totalPages"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer bg-transparent">
            <span class="material-icons text-sm">chevron_right</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- EDIT / VIEW -->
  <ng-container *ngIf="viewMode() === 'edit'">
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
      <div>
        <button type="button" (click)="backToList()"
          class="mb-2 inline-flex items-center gap-1 text-xs font-bold text-slate-400 hover:text-amber-600 transition-colors border-none bg-transparent cursor-pointer p-0">
          <span class="material-icons text-[16px]">arrow_back</span>
          กลับรายการ
        </button>
        <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
          <span class="w-11 h-11 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 text-slate-900 inline-flex items-center justify-center shadow-[0_8px_20px_-6px_rgba(251,191,36,0.55)]">
            <span class="material-icons">{{ draft().isEditable ? (draft().id ? 'edit_note' : 'add_circle') : 'campaign' }}</span>
          </span>
          {{ draft().isEditable ? (draft().id ? 'แก้ไขแคมเปญ' : 'สร้างแคมเปญ') : (draft().title || 'รายละเอียดแคมเปญ') }}
        </h1>
        <div class="mt-2 flex items-center gap-2">
          <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold" [ngClass]="statusMeta(draft().status).className">
            <span class="material-icons text-[14px]" [class.animate-pulse]="draft().status === 'sending'">{{ statusMeta(draft().status).icon }}</span>
            {{ statusMeta(draft().status).label }}
          </span>
          <span *ngIf="draft().lastTestAt" class="text-xs text-slate-400">ทดสอบล่าสุด {{ draft().lastTestAt | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
      </div>
      <div class="flex flex-wrap items-center gap-3 self-start md:self-end">
        <button *ngIf="canShowActivityHistory" type="button" (click)="openHistory()"
          class="px-4 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-600 dark:text-slate-300 font-bold rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all flex items-center justify-center gap-2 cursor-pointer">
          <span class="material-icons text-[18px]">history</span>
          ดูประวัติ
        </button>
        <ng-container *ngIf="isEditable">
          <button type="button" (click)="onSaveDraft()" [disabled]="isSaving() || !!uploadingKey()"
            class="px-5 h-[46px] bg-white/95 dark:bg-slate-800/95 text-slate-700 dark:text-slate-200 font-bold rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:bg-slate-50 transition-all flex items-center gap-2 disabled:opacity-40 cursor-pointer">
            <span class="material-icons text-[18px]">save</span>
            บันทึกร่าง
          </button>
          <button type="button" (click)="askSend()" [disabled]="isSaving() || !!uploadingKey() || quotaInsufficient"
            class="px-6 h-[46px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center gap-2 disabled:opacity-40 border-none cursor-pointer">
            <span class="material-icons text-[18px]">send</span>
            ส่งจริง
          </button>
        </ng-container>
        <button *ngIf="canUpdate && (draft().status === 'partial' || draft().status === 'failed')" type="button" (click)="askRetry()" [disabled]="isSaving()"
          class="px-6 h-[46px] bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center gap-2 disabled:opacity-40 border-none cursor-pointer">
          <span class="material-icons text-[18px]">replay</span>
          ส่งซ้ำชุดที่ล้ม
        </button>
      </div>
    </div>

    <div class="grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_380px] gap-6 animate-fade-in">
      <!-- LEFT: form / result -->
      <div class="space-y-6 min-w-0">
        <!-- Result (after send) -->
        <section *ngIf="!draft().isEditable" class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-5">
          <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">insights</span>
            ผลการส่ง
          </h2>
          <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
            <div class="rounded-2xl bg-slate-50 dark:bg-slate-800 p-4">
              <p class="text-[11px] font-bold text-slate-400 uppercase">ผู้รับ</p>
              <p class="text-2xl font-black text-slate-800 dark:text-slate-100 tabular-nums">{{ draft().recipientCount | number }}</p>
            </div>
            <div class="rounded-2xl bg-emerald-50 dark:bg-emerald-900/20 p-4">
              <p class="text-[11px] font-bold text-emerald-600 uppercase">ส่งสำเร็จ</p>
              <p class="text-2xl font-black text-emerald-700 dark:text-emerald-400 tabular-nums">{{ draft().successCount | number }}</p>
            </div>
            <div class="rounded-2xl bg-rose-50 dark:bg-rose-900/20 p-4">
              <p class="text-[11px] font-bold text-rose-500 uppercase">ไม่สำเร็จ</p>
              <p class="text-2xl font-black text-rose-600 dark:text-rose-400 tabular-nums">{{ draft().failCount | number }}</p>
            </div>
            <div class="rounded-2xl bg-slate-50 dark:bg-slate-800 p-4">
              <p class="text-[11px] font-bold text-slate-400 uppercase">กลุ่มผู้รับ</p>
              <p class="text-sm font-bold text-slate-700 dark:text-slate-200 mt-1">{{ audienceLabel(draft().audienceType) }}</p>
              <p *ngIf="draft().audienceType === 'monthly_active'" class="text-[11px] text-slate-500 mt-0.5 truncate" [title]="draft().siteNames.join(', ')">
                {{ draft().siteNames.length ? draft().siteNames.join(', ') : 'ทุก site' }}
              </p>
              <p *ngIf="draft().excludedUserIds.length" class="text-[11px] text-rose-500 mt-0.5">ติ๊กออก {{ draft().excludedUserIds.length | number }} คน</p>
            </div>
          </div>
          <div class="text-xs text-slate-500 space-y-1">
            <p>ส่งเมื่อ {{ draft().sentAt ? (draft().sentAt | date:'dd/MM/yyyy HH:mm') : '—' }} <span *ngIf="draft().sentByName">โดย {{ draft().sentByName }}</span></p>
            <p *ngIf="draft().completedAt">เสร็จเมื่อ {{ draft().completedAt | date:'dd/MM/yyyy HH:mm' }}</p>
            <p *ngIf="draft().quotaRemainingAtSend !== null">โควตา LINE คงเหลือตอนส่ง {{ draft().quotaRemainingAtSend | number }}</p>
          </div>
          <div *ngIf="draft().status === 'sending'" class="rounded-2xl border border-sky-100 dark:border-sky-900/40 bg-sky-50/70 dark:bg-sky-950/20 p-4 space-y-2">
            <div class="flex items-center justify-between text-sm">
              <span class="font-bold text-sky-700 dark:text-sky-300 flex items-center gap-2">
                <span class="material-icons text-[18px] animate-spin">autorenew</span>
                กำลังส่ง...
              </span>
              <span class="font-black text-sky-700 dark:text-sky-300 tabular-nums">{{ progress()?.percent ?? 0 }}%</span>
            </div>
            <div class="h-2.5 rounded-full bg-sky-100 dark:bg-sky-900/50 overflow-hidden">
              <div class="h-full rounded-full bg-gradient-to-r from-sky-500 to-amber-400 transition-all duration-500"
                [style.width.%]="progress()?.percent ?? 0"></div>
            </div>
            <p class="text-[11px] text-sky-600/80 dark:text-sky-400/80 tabular-nums">
              {{ (progress()?.processedCount ?? 0) | number }} / {{ draft().recipientCount | number }} คน
              · ชุด {{ progress()?.batchDone ?? 0 }}/{{ progress()?.batchTotal ?? 0 }}
              — ออกจากหน้านี้ได้ ระบบส่งต่อเบื้องหลัง
            </p>
          </div>
          <div *ngIf="draft().errorMessage" class="rounded-xl border border-rose-200 bg-rose-50/70 dark:bg-rose-950/20 p-3 text-sm text-rose-700 dark:text-rose-300">
            {{ draft().errorMessage }}
          </div>

          <div *ngIf="draft().batches.length" class="overflow-x-auto custom-scrollbar">
            <table class="w-full text-left text-xs">
              <thead>
                <tr class="text-slate-400 font-bold uppercase border-b border-slate-100 dark:border-slate-700">
                  <th class="py-2 pr-3">ชุด</th>
                  <th class="py-2 pr-3 text-right">ผู้รับ</th>
                  <th class="py-2 pr-3">สถานะ</th>
                  <th class="py-2 pr-3 text-right">ครั้งที่ลอง</th>
                  <th class="py-2 pr-3">หมายเหตุ</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
                <tr *ngFor="let b of draft().batches">
                  <td class="py-2 pr-3 font-bold">#{{ b.batchNo }}</td>
                  <td class="py-2 pr-3 text-right tabular-nums">{{ b.recipientCount | number }}</td>
                  <td class="py-2 pr-3">
                    <span class="font-bold" [ngClass]="b.status === 'sent' ? 'text-emerald-600' : b.status === 'failed' ? 'text-rose-500' : 'text-sky-600'">
                      {{ b.status === 'sent' ? 'สำเร็จ' : b.status === 'failed' ? 'ล้มเหลว' : 'รอส่ง' }}
                    </span>
                  </td>
                  <td class="py-2 pr-3 text-right tabular-nums">{{ b.attemptCount }}</td>
                  <td class="py-2 pr-3 text-slate-400 max-w-[360px] truncate" [title]="b.errorMessage">{{ b.errorMessage || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <!-- Campaign + audience -->
        <section class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-5">
          <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
            <span class="material-icons text-amber-500">tune</span>
            ข้อมูลแคมเปญ
          </h2>
          <div class="grid grid-cols-1 gap-4">
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อแคมเปญ (ภายใน) <span class="text-rose-500">*</span></label>
              <input [disabled]="!isEditable" maxlength="200"
                class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-70"
                [ngModel]="draft().title" (ngModelChange)="patchDraft({ title: $event })" [ngModelOptions]="{ standalone: true }"
                placeholder="เช่น โปรโมชั่นรายเดือน ต.ค. 2026" />
            </div>
            <div>
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">รูปแบบข้อความ</label>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                <button *ngFor="let t of messageTypes" type="button" [disabled]="!isEditable" (click)="setMessageType(t.value)"
                  class="text-left rounded-2xl border-2 p-4 transition-all flex items-start gap-3 cursor-pointer disabled:cursor-default bg-transparent"
                  [ngClass]="draft().messageType === t.value
                    ? 'border-amber-400 bg-amber-50/60 dark:bg-amber-900/10'
                    : 'border-slate-100 dark:border-slate-700 hover:border-amber-200'"
                  [class.opacity-50]="!isEditable && draft().messageType !== t.value">
                  <span class="w-10 h-10 rounded-xl inline-flex items-center justify-center shrink-0"
                    [ngClass]="draft().messageType === t.value ? 'bg-amber-400 text-slate-900' : 'bg-slate-100 dark:bg-slate-800 text-slate-400'">
                    <span class="material-icons">{{ t.icon }}</span>
                  </span>
                  <span class="min-w-0">
                    <span class="block font-bold text-slate-700 dark:text-slate-200">{{ t.label }}</span>
                    <span class="block text-xs text-slate-400">{{ t.description }}</span>
                  </span>
                </button>
              </div>
            </div>
            <div *ngIf="draft().messageType !== 'image'">
              <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
                ข้อความแจ้งเตือน <span class="text-rose-500">*</span>
                <span class="normal-case font-medium text-slate-400">— แสดงในรายการแชท / การแจ้งเตือนบนมือถือ</span>
              </label>
              <input [disabled]="!isEditable" [maxlength]="maxAltText"
                class="w-full h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-70"
                [ngModel]="draft().altText" (ngModelChange)="patchDraft({ altText: $event })" [ngModelOptions]="{ standalone: true }"
                placeholder="เช่น City Parking: โปรพิเศษสำหรับสมาชิก" />
              <p class="text-[11px] text-slate-400 mt-1 text-right tabular-nums">{{ draft().altText.length }}/{{ maxAltText }}</p>
            </div>
          </div>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">กลุ่มผู้รับ</label>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div *ngFor="let a of audiences" class="relative">
                <button type="button" [disabled]="!isEditable" (click)="setAudience(a.value)"
                  class="w-full h-full text-left rounded-2xl border-2 p-4 transition-all flex items-start gap-3 cursor-pointer disabled:cursor-default bg-transparent"
                  [class.pb-12]="a.value === 'monthly_active'"
                  [ngClass]="draft().audienceType === a.value
                    ? 'border-amber-400 bg-amber-50/60 dark:bg-amber-900/10'
                    : 'border-slate-100 dark:border-slate-700 hover:border-amber-200'">
                  <span class="w-10 h-10 rounded-xl inline-flex items-center justify-center shrink-0"
                    [ngClass]="draft().audienceType === a.value ? 'bg-amber-400 text-slate-900' : 'bg-slate-100 dark:bg-slate-800 text-slate-400'">
                    <span class="material-icons">{{ a.icon }}</span>
                  </span>
                  <span class="min-w-0 flex-1">
                    <span class="block font-bold text-slate-700 dark:text-slate-200">{{ a.label }}</span>
                    <span class="block text-xs text-slate-400">{{ a.description }}</span>
                    <span *ngIf="a.value === 'monthly_active'" class="block text-[11px] text-amber-700 dark:text-amber-400 font-semibold mt-1 truncate">
                      site: {{ isEditable ? (navSiteName || '—') : (draft().siteNames.join(', ') || 'ทุก site') }}
                    </span>
                  </span>
                  <span class="text-right shrink-0">
                    <span class="block text-lg font-black tabular-nums text-slate-800 dark:text-slate-100">
                      {{ audienceCount(a.value) === null ? '…' : (audienceCount(a.value) | number) }}
                    </span>
                    <span class="block text-[10px] text-slate-400 font-bold">คน</span>
                  </span>
                </button>
                <button *ngIf="a.value === 'monthly_active'" type="button" (click)="openMonthlyDetail($event)"
                  class="absolute right-3 bottom-3 h-8 px-3 rounded-lg bg-white/90 dark:bg-slate-800 border border-amber-200 dark:border-amber-800 text-amber-700 dark:text-amber-400 text-xs font-bold inline-flex items-center gap-1 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors cursor-pointer">
                  <span class="material-icons text-[16px]">visibility</span>
                  รายละเอียด
                </button>
              </div>
            </div>
          </div>

          <!-- Site (monthly only) — follows the nav-bar site -->
          <div *ngIf="draft().audienceType === 'monthly_active'" class="rounded-2xl border border-slate-100 dark:border-slate-700 p-4 flex items-start gap-3">
            <span class="material-icons text-[20px] text-amber-500">location_city</span>
            <div class="min-w-0 text-xs">
              <p class="font-bold text-slate-700 dark:text-slate-200">
                site: {{ isEditable ? (navSiteName || '—') : (draft().siteNames.join(', ') || 'ทุก site') }}
              </p>
              <p class="text-[11px] text-slate-400 mt-0.5">
                <ng-container *ngIf="isEditable">ใช้ site ที่เลือกจากแถบด้านบน — เปลี่ยน site ที่แถบด้านบนเพื่อส่งหาสมาชิกของลานอื่น · </ng-container>
                นับเฉพาะบัตรรายเดือนแบบเสียเงินที่ยังไม่หมดอายุ (ไม่รวมสมาชิกฟรี) ที่ parking_card.uid ตรงกับ LINE ของสมาชิก — คนที่มีหลายใบได้รับครั้งเดียว
              </p>
            </div>
          </div>

          <!-- Screening -->
          <div class="rounded-2xl border border-slate-100 dark:border-slate-700 overflow-hidden">
            <button type="button" (click)="toggleMemberList()"
              class="w-full px-4 py-3 flex flex-wrap items-center justify-between gap-2 bg-slate-50/70 dark:bg-slate-800/60 hover:bg-amber-50/60 dark:hover:bg-amber-900/10 transition-colors text-left">
              <span class="flex items-center gap-2 text-sm font-bold text-slate-700 dark:text-slate-200">
                <span class="material-icons text-amber-500">fact_check</span>
                รายชื่อผู้รับ / คัดกรอง
                <span class="text-xs font-medium text-slate-400">
                  ส่งจริง <b class="text-slate-700 dark:text-slate-200 tabular-nums">{{ selectedAudienceCount === null ? '…' : (selectedAudienceCount | number) }}</b> คน
                  <ng-container *ngIf="excludedInAudienceCount > 0"> · ติ๊กออก <b class="text-rose-500 tabular-nums">{{ excludedInAudienceCount | number }}</b></ng-container>
                </span>
              </span>
              <span class="material-icons text-slate-400 transition-transform" [class.rotate-180]="showMemberList()">expand_more</span>
            </button>

            <div *ngIf="showMemberList()" class="p-4 space-y-3 animate-fade-in">
              <div class="flex flex-wrap items-center gap-2">
                <div class="relative flex-1 min-w-[200px]">
                  <span class="material-icons absolute left-3 top-1/2 -translate-y-1/2 text-[18px] text-slate-400">search</span>
                  <input [(ngModel)]="membersSearch" [ngModelOptions]="{ standalone: true }" (keyup.enter)="onMembersSearch()"
                    placeholder="ค้นหาชื่อ / เบอร์โทร แล้วกด Enter"
                    class="w-full h-10 pl-10 pr-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-amber-200" />
                </div>
                <button *ngIf="isEditable && excludedCount" type="button" (click)="clearExcluded()"
                  class="h-10 px-3 rounded-xl text-xs font-bold text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-950/20 transition-colors">
                  เอาทุกคนกลับ ({{ excludedCount | number }})
                </button>
              </div>

              <div class="overflow-x-auto custom-scrollbar relative min-h-[120px]">
                <div *ngIf="isMembersLoading()" class="absolute inset-0 z-10 flex items-center justify-center bg-white/60 dark:bg-slate-900/60">
                  <span class="material-icons animate-spin text-amber-500">autorenew</span>
                </div>
                <table class="w-full text-left text-sm">
                  <thead>
                    <tr class="text-[11px] text-slate-400 font-bold uppercase border-b border-slate-100 dark:border-slate-700">
                      <th class="py-2 pr-3 w-10">
                        <button type="button" [disabled]="!isEditable || !members().length" (click)="toggleWholePage()"
                          [title]="isWholePageIncluded ? 'ติ๊กออกทั้งหน้า' : 'เอาทั้งหน้ากลับ'"
                          class="material-icons text-[20px] disabled:opacity-40"
                          [ngClass]="isWholePageIncluded ? 'text-amber-500' : 'text-slate-300'">
                          {{ isWholePageIncluded ? 'check_box' : 'indeterminate_check_box' }}
                        </button>
                      </th>
                      <th class="py-2 pr-3">สมาชิก</th>
                      <th class="py-2 pr-3">เบอร์โทร</th>
                      <th *ngIf="draft().audienceType === 'monthly_active'" class="py-2 pr-3">site ที่มีบัตร</th>
                      <th *ngIf="draft().audienceType === 'monthly_active'" class="py-2 pr-3">บัตรหมดอายุ</th>
                      <th class="py-2 pr-3">เข้าใช้ล่าสุด</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
                    <tr *ngFor="let m of members()" class="transition-colors"
                      [ngClass]="isExcluded(m.cpUserId) ? 'opacity-50 bg-rose-50/40 dark:bg-rose-950/10' : 'hover:bg-amber-50/40 dark:hover:bg-amber-900/10'">
                      <td class="py-2 pr-3">
                        <button type="button" [disabled]="!isEditable" (click)="toggleMember(m.cpUserId)"
                          class="material-icons text-[20px] disabled:cursor-default"
                          [ngClass]="isExcluded(m.cpUserId) ? 'text-slate-300' : 'text-amber-500'">
                          {{ isExcluded(m.cpUserId) ? 'check_box_outline_blank' : 'check_box' }}
                        </button>
                      </td>
                      <td class="py-2 pr-3">
                        <span class="font-semibold text-slate-700 dark:text-slate-200" [class.line-through]="isExcluded(m.cpUserId)">{{ m.name }}</span>
                      </td>
                      <td class="py-2 pr-3 tabular-nums text-slate-500">{{ m.phone || '—' }}</td>
                      <td *ngIf="draft().audienceType === 'monthly_active'" class="py-2 pr-3 text-xs text-slate-500 max-w-[220px] truncate" [title]="m.siteNames.join(', ')">
                        {{ m.siteNames.join(', ') || '—' }}
                      </td>
                      <td *ngIf="draft().audienceType === 'monthly_active'" class="py-2 pr-3 text-xs tabular-nums text-slate-500">
                        {{ m.cardEndDate ? (m.cardEndDate | date:'dd/MM/yyyy') : '—' }}
                      </td>
                      <td class="py-2 pr-3 text-xs tabular-nums text-slate-400">{{ m.lastLogin ? (m.lastLogin | date:'dd/MM/yyyy') : '—' }}</td>
                    </tr>
                    <tr *ngIf="!members().length && !isMembersLoading()">
                      <td colspan="6" class="py-8 text-center text-xs text-slate-400">ไม่พบสมาชิกในกลุ่มนี้</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="flex items-center justify-between text-xs text-slate-500">
                <span class="tabular-nums">ทั้งหมด {{ membersTotal() | number }} คน · หน้า {{ membersPage() }}/{{ membersTotalPages }}</span>
                <div class="flex items-center gap-1">
                  <button type="button" (click)="onMembersPageChange(membersPage() - 1)" [disabled]="membersPage() <= 1"
                    class="w-8 h-8 rounded-lg inline-flex items-center justify-center hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-40">
                    <span class="material-icons text-[18px]">chevron_left</span>
                  </button>
                  <button type="button" (click)="onMembersPageChange(membersPage() + 1)" [disabled]="membersPage() >= membersTotalPages"
                    class="w-8 h-8 rounded-lg inline-flex items-center justify-center hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-40">
                    <span class="material-icons text-[18px]">chevron_right</span>
                  </button>
                </div>
              </div>
              <p *ngIf="isEditable" class="text-[11px] text-slate-400">
                ติ๊กออกได้สูงสุด {{ maxExcluded | number }} คน · สมาชิกที่เข้ากลุ่มหลังบันทึกร่างจะได้รับด้วย · กดบันทึกร่างเพื่อเก็บการคัดกรอง
              </p>
            </div>
          </div>

          <div *ngIf="isEditable" class="rounded-2xl p-4 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs"
            [ngClass]="quotaInsufficient ? 'bg-rose-50 dark:bg-rose-950/20 text-rose-700' : 'bg-slate-50 dark:bg-slate-800 text-slate-500'">
            <span class="flex items-center gap-1 font-bold">
              <span class="material-icons text-[18px]">{{ quotaInsufficient ? 'error' : 'data_usage' }}</span>
              โควตาข้อความ LINE
              <span *ngIf="quota()?.tokenProfile" class="px-2 py-0.5 rounded-full bg-white/70 dark:bg-slate-700 text-[10px]">{{ quota()?.tokenProfile }}</span>
            </span>
            <ng-container *ngIf="quota() as q; else quotaLoading">
              <ng-container *ngIf="q.isSuccess; else quotaError">
                <span *ngIf="q.isUnlimited">ไม่จำกัด (ใช้ไปแล้ว {{ q.used | number }})</span>
                <span *ngIf="!q.isUnlimited">คงเหลือ <b class="tabular-nums">{{ q.remaining | number }}</b> / {{ q.limit | number }} (ใช้ไป {{ q.used | number }})</span>
              </ng-container>
            </ng-container>
            <ng-template #quotaLoading><span>กำลังโหลด…</span></ng-template>
            <ng-template #quotaError><span>อ่านโควตาไม่ได้ — ระบบยังส่งได้แต่ LINE อาจปฏิเสธถ้าเกินโควตา</span></ng-template>
            <span *ngIf="quotaInsufficient" class="font-bold">โควตาไม่พอสำหรับผู้รับ {{ selectedAudienceCount | number }} คน</span>
          </div>
        </section>

        <!-- Images (image mode) -->
        <section *ngIf="draft().messageType === 'image'" class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-5">
          <div class="flex items-center justify-between gap-3">
            <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
              <span class="material-icons text-amber-500">image</span>
              รูปภาพ
              <span class="text-xs font-bold text-slate-400">{{ draft().images.length }}/{{ maxImages }}</span>
            </h2>
            <label *ngIf="isEditable"
              class="px-4 h-10 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 font-bold text-xs flex items-center gap-1 hover:bg-amber-100 cursor-pointer"
              [class.opacity-40]="draft().images.length >= maxImages || !!uploadingKey()"
              [class.pointer-events-none]="draft().images.length >= maxImages || !!uploadingKey()">
              <span class="material-icons text-[18px]" [class.animate-spin]="uploadingKey() === imageUploadKey">
                {{ uploadingKey() === imageUploadKey ? 'progress_activity' : 'add_photo_alternate' }}
              </span>
              {{ uploadingKey() === imageUploadKey ? 'กำลังอัปโหลด...' : 'เพิ่มรูป' }}
              <input type="file" accept="image/*" multiple class="hidden" (change)="onImagesSelected($event)" />
            </label>
          </div>
          <p class="text-xs text-slate-400">
            ส่งเป็นรูปแยกทีละรูปในแชท · กดดูรูปขยายได้แต่ไม่มีลิงก์ · ส่งได้สูงสุด {{ maxImages }} รูป
            (LINE ส่งได้ครั้งละ 5 ข้อความ — ถ้าแนบข้อความจะเหลือ 4 รูป)
          </p>

          <div *ngIf="draft().images.length; else noImages" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
            <div *ngFor="let img of draft().images; let i = index; trackBy: trackByImage"
              class="rounded-2xl border border-slate-100 dark:border-slate-700 overflow-hidden bg-slate-50/40 dark:bg-slate-800/40">
              <div class="relative aspect-square bg-white dark:bg-slate-900">
                <img [src]="img.imageUrl" alt="" class="w-full h-full object-cover" />
                <span class="absolute top-2 left-2 w-6 h-6 rounded-full bg-slate-900/70 text-white text-[11px] font-black inline-flex items-center justify-center">{{ i + 1 }}</span>
              </div>
              <div *ngIf="isEditable" class="flex items-center justify-between p-1">
                <button type="button" (click)="moveImage(i, -1)" [disabled]="i === 0" title="เลื่อนก่อน"
                  class="w-8 h-8 rounded-lg inline-flex items-center justify-center text-slate-400 hover:text-amber-500 disabled:opacity-30 border-none bg-transparent cursor-pointer">
                  <span class="material-icons text-[18px]">arrow_back</span>
                </button>
                <button type="button" (click)="removeImage(img.uiKey)" title="ลบรูป"
                  class="w-8 h-8 rounded-lg inline-flex items-center justify-center text-slate-400 hover:text-rose-500 border-none bg-transparent cursor-pointer">
                  <span class="material-icons text-[18px]">delete</span>
                </button>
                <button type="button" (click)="moveImage(i, 1)" [disabled]="i === draft().images.length - 1" title="เลื่อนหลัง"
                  class="w-8 h-8 rounded-lg inline-flex items-center justify-center text-slate-400 hover:text-amber-500 disabled:opacity-30 border-none bg-transparent cursor-pointer">
                  <span class="material-icons text-[18px]">arrow_forward</span>
                </button>
              </div>
            </div>
          </div>
          <ng-template #noImages>
            <div class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-600 py-10 text-center text-slate-400">
              <span class="material-icons text-4xl opacity-40 block mb-1">collections</span>
              <p class="text-xs font-bold">ยังไม่มีรูป — กด “เพิ่มรูป” (เลือกหลายรูปพร้อมกันได้)</p>
            </div>
          </ng-template>

          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
              ข้อความแนบท้าย (ไม่บังคับ)
              <span class="normal-case font-medium text-slate-400">— ส่งต่อจากรูป และแสดงในรายการแชท / การแจ้งเตือน</span>
            </label>
            <textarea [disabled]="!isEditable" [maxlength]="maxImageText" rows="3"
              class="w-full px-4 py-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200 resize-y disabled:opacity-70"
              [ngModel]="draft().imageText" (ngModelChange)="patchDraft({ imageText: $event })" [ngModelOptions]="{ standalone: true }"
              placeholder="เช่น แจ้งปิดปรับปรุงลานจอด 1–3 ต.ค. ขออภัยในความไม่สะดวก"></textarea>
            <div class="flex items-center justify-between mt-1 text-[11px]">
              <span class="text-slate-400">ถ้าไม่แนบข้อความ การแจ้งเตือนบนมือถือจะขึ้นว่า “ส่งรูปภาพ”</span>
              <span class="text-slate-400 tabular-nums">{{ draft().imageText.length }}/{{ maxImageText }}</span>
            </div>
            <p *ngIf="draft().imageText.trim() && draft().images.length > maxImages" class="text-[11px] text-rose-500 font-bold mt-1">
              แนบข้อความแล้วส่งรูปได้ไม่เกิน {{ maxImages }} รูป — ลบรูปออก {{ draft().images.length - maxImages }} รูป
            </p>
          </div>
        </section>

        <!-- News (news mode) -->
        <section *ngIf="draft().messageType === 'news'" class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-5">
          <div class="flex items-center justify-between gap-3">
            <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
              <span class="material-icons text-amber-500">campaign</span>
              ประกาศที่จะแจ้ง
              <span class="text-xs font-bold text-slate-400">{{ draft().news.length }}/{{ maxNews }}</span>
            </h2>
            <button *ngIf="isEditable" type="button" (click)="showNewsPicker() ? closeNewsPicker() : openNewsPicker()"
              class="px-4 h-10 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 font-bold text-xs flex items-center gap-1 hover:bg-amber-100 border-none cursor-pointer">
              <span class="material-icons text-[18px]">{{ showNewsPicker() ? 'expand_less' : 'playlist_add' }}</span>
              {{ showNewsPicker() ? 'ซ่อนรายการ' : 'เลือกประกาศ' }}
            </button>
          </div>
          <p class="text-xs text-slate-400">
            ดึงหัวข้อ / สรุป / รูปปกจากประกาศจริงตอนส่ง · ปุ่ม “อ่านรายละเอียด” เปิดหน้าประกาศใน LIFF ·
            1 รายการ = การ์ดเดี่ยว · 2–{{ maxNews }} = เลื่อนซ้ายขวา
          </p>

          <!-- Picker -->
          <div *ngIf="isEditable && showNewsPicker()" class="rounded-2xl border border-amber-200 dark:border-amber-900/40 bg-amber-50/30 dark:bg-amber-950/10 p-4 space-y-3 animate-fade-in">
            <div class="relative">
              <span class="material-icons absolute left-3 top-1/2 -translate-y-1/2 text-[18px] text-slate-400">search</span>
              <input [(ngModel)]="newsSearch" [ngModelOptions]="{ standalone: true }" (keyup.enter)="onNewsSearch()"
                placeholder="ค้นหาหัวข้อ / สรุป / ชื่อลาน แล้วกด Enter"
                class="w-full h-10 pl-10 pr-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-amber-200" />
            </div>
            <div class="relative max-h-80 overflow-y-auto custom-scrollbar space-y-2 min-h-[80px]">
              <div *ngIf="isNewsLoading()" class="absolute inset-0 z-10 flex items-center justify-center bg-white/60 dark:bg-slate-900/60">
                <span class="material-icons animate-spin text-amber-500">autorenew</span>
              </div>
              <button *ngFor="let n of newsOptions(); trackBy: trackByNews" type="button" (click)="toggleNews(n)"
                class="w-full text-left rounded-xl border p-2 flex items-center gap-3 transition-all cursor-pointer bg-white dark:bg-slate-900"
                [ngClass]="isNewsSelected(n.id) ? 'border-amber-400 ring-1 ring-amber-300' : 'border-slate-100 dark:border-slate-700 hover:border-amber-200'">
                <span class="material-icons text-[20px] shrink-0" [ngClass]="isNewsSelected(n.id) ? 'text-amber-500' : 'text-slate-300'">
                  {{ isNewsSelected(n.id) ? 'check_circle' : 'radio_button_unchecked' }}
                </span>
                <span class="w-16 h-11 rounded-lg overflow-hidden bg-slate-100 dark:bg-slate-800 shrink-0 flex items-center justify-center">
                  <img *ngIf="n.coverImageUrl" [src]="n.coverImageUrl" alt="" class="w-full h-full object-cover" />
                  <span *ngIf="!n.coverImageUrl" class="material-icons text-slate-300">article</span>
                </span>
                <span class="min-w-0 flex-1">
                  <span class="flex items-center gap-1.5 font-bold text-slate-700 dark:text-slate-200 text-sm">
                    <span *ngIf="n.pin" class="material-icons text-[14px] text-amber-500" title="ปักหมุด">push_pin</span>
                    <span class="truncate">{{ n.title }}</span>
                  </span>
                  <span class="block text-[11px] text-slate-400 truncate">
                    {{ n.siteName ? 'ลาน ' + n.siteName : 'City Parking (ข่าวรวม)' }}
                    <ng-container *ngIf="n.categoryName"> · {{ n.categoryName }}</ng-container>
                    <ng-container *ngIf="n.publishTo"> · ถึง {{ n.publishTo | date:'dd/MM/yyyy' }}</ng-container>
                  </span>
                </span>
              </button>
              <p *ngIf="!isNewsLoading() && !newsOptions().length" class="py-6 text-center text-xs text-slate-400">
                ไม่พบประกาศที่เผยแพร่อยู่ (ต้องเป็นสาธารณะ + เผยแพร่ + อยู่ในช่วงเวลาเผยแพร่)
              </p>
            </div>
          </div>

          <!-- Selected -->
          <div *ngIf="draft().news.length; else noNews" class="space-y-2">
            <div *ngFor="let n of draft().news; let i = index; trackBy: trackByNews"
              class="rounded-2xl border p-3 flex items-center gap-3"
              [ngClass]="n.isAvailable ? 'border-slate-100 dark:border-slate-700 bg-slate-50/40 dark:bg-slate-800/40' : 'border-rose-200 bg-rose-50/60 dark:bg-rose-950/20'">
              <span class="w-6 h-6 rounded-full bg-slate-900/80 text-white text-[11px] font-black inline-flex items-center justify-center shrink-0">{{ i + 1 }}</span>
              <span class="w-20 aspect-[20/13] rounded-lg overflow-hidden bg-slate-100 dark:bg-slate-800 shrink-0 flex items-center justify-center">
                <img *ngIf="n.coverImageUrl" [src]="n.coverImageUrl" alt="" class="w-full h-full object-cover" />
                <span *ngIf="!n.coverImageUrl" class="material-icons text-slate-300">article</span>
              </span>
              <div class="min-w-0 flex-1">
                <p class="font-bold text-slate-700 dark:text-slate-200 truncate">{{ n.title }}</p>
                <p class="text-[11px] text-slate-400 truncate">{{ n.siteName ? 'ลาน ' + n.siteName : 'City Parking (ข่าวรวม)' }}</p>
                <p *ngIf="!n.isAvailable" class="text-[11px] text-rose-600 font-bold">ไม่อยู่ในสถานะเผยแพร่แล้ว — นำออกก่อนส่ง</p>
              </div>
              <div *ngIf="isEditable" class="flex items-center gap-0.5 shrink-0">
                <button type="button" (click)="moveNews(i, -1)" [disabled]="i === 0" title="เลื่อนขึ้น"
                  class="w-8 h-8 rounded-lg inline-flex items-center justify-center text-slate-400 hover:text-amber-500 disabled:opacity-30 border-none bg-transparent cursor-pointer">
                  <span class="material-icons text-[18px]">arrow_upward</span>
                </button>
                <button type="button" (click)="moveNews(i, 1)" [disabled]="i === draft().news.length - 1" title="เลื่อนลง"
                  class="w-8 h-8 rounded-lg inline-flex items-center justify-center text-slate-400 hover:text-amber-500 disabled:opacity-30 border-none bg-transparent cursor-pointer">
                  <span class="material-icons text-[18px]">arrow_downward</span>
                </button>
                <button type="button" (click)="removeNews(n.id)" title="นำออก"
                  class="w-8 h-8 rounded-lg inline-flex items-center justify-center text-slate-400 hover:text-rose-500 border-none bg-transparent cursor-pointer">
                  <span class="material-icons text-[18px]">close</span>
                </button>
              </div>
            </div>
          </div>
          <ng-template #noNews>
            <div class="rounded-2xl border border-dashed border-slate-200 dark:border-slate-600 py-10 text-center text-slate-400">
              <span class="material-icons text-4xl opacity-40 block mb-1">campaign</span>
              <p class="text-xs font-bold">ยังไม่ได้เลือกประกาศ</p>
            </div>
          </ng-template>

          <div *ngIf="isEditable && selectedNewsSiteIds.length"
            class="rounded-2xl p-4 flex flex-wrap items-center justify-between gap-3 text-xs"
            [ngClass]="isAudienceMatchingNewsSites ? 'bg-emerald-50 dark:bg-emerald-950/20 text-emerald-700 dark:text-emerald-300' : 'bg-sky-50 dark:bg-sky-950/20 text-sky-700 dark:text-sky-300'">
            <span class="flex items-center gap-2 font-semibold">
              <span class="material-icons text-[18px]">{{ isAudienceMatchingNewsSites ? 'check_circle' : 'lightbulb' }}</span>
              <ng-container *ngIf="isAudienceMatchingNewsSites; else audienceHint">
                ส่งเฉพาะสมาชิกรายเดือนของ {{ navSiteName }} แล้ว
              </ng-container>
              <ng-template #audienceHint>
                <ng-container *ngIf="isNewsSiteOnNav; else otherSiteHint">
                  เป็นประกาศของลาน {{ navSiteName }} — ส่งเฉพาะสมาชิกรายเดือนของลานนี้ไหม?
                </ng-container>
                <ng-template #otherSiteHint>
                  เป็นประกาศของลาน {{ selectedNewsSiteNames.join(', ') }} — เลือก site นี้ที่แถบด้านบน หากต้องการส่งเฉพาะสมาชิกรายเดือนของลาน
                </ng-template>
              </ng-template>
            </span>
            <button *ngIf="!isAudienceMatchingNewsSites && isNewsSiteOnNav" type="button" (click)="applyNewsSiteAudience()"
              class="h-8 px-3 rounded-lg bg-white/80 dark:bg-slate-800 font-bold hover:bg-white border-none cursor-pointer">
              ตั้งกลุ่มผู้รับตามลาน
            </button>
          </div>
        </section>

        <!-- Bubbles (card mode) -->
        <section *ngIf="draft().messageType === 'card'" class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-5">
          <div class="flex items-center justify-between gap-3">
            <h2 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
              <span class="material-icons text-amber-500">view_carousel</span>
              การ์ดข้อความ
              <span class="text-xs font-bold text-slate-400">{{ draft().bubbles.length }}/{{ maxBubbles }}</span>
            </h2>
            <button *ngIf="isEditable" type="button" (click)="addBubble()" [disabled]="draft().bubbles.length >= maxBubbles"
              class="px-4 h-10 rounded-xl bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 font-bold text-xs flex items-center gap-1 hover:bg-amber-100 disabled:opacity-40 border-none cursor-pointer">
              <span class="material-icons text-[18px]">add</span>
              เพิ่มการ์ด
            </button>
          </div>
          <p class="text-xs text-slate-400">1 ใบ = การ์ดเดี่ยว · 2–5 ใบ = เลื่อนซ้ายขวา (carousel) · สีธีม City Parking คงที่</p>

          <div *ngFor="let b of draft().bubbles; let i = index; trackBy: trackByBubble"
            class="rounded-2xl border border-slate-100 dark:border-slate-700 p-4 md:p-5 space-y-4 bg-slate-50/40 dark:bg-slate-800/40">
            <div class="flex items-center justify-between">
              <span class="text-sm font-black text-slate-700 dark:text-slate-200">การ์ดที่ {{ i + 1 }}</span>
              <div *ngIf="isEditable" class="flex items-center gap-1">
                <button type="button" (click)="moveBubble(i, -1)" [disabled]="i === 0" title="เลื่อนขึ้น"
                  class="w-8 h-8 rounded-lg inline-flex items-center justify-center text-slate-400 hover:text-amber-500 disabled:opacity-30 border-none bg-transparent cursor-pointer">
                  <span class="material-icons text-[18px]">arrow_upward</span>
                </button>
                <button type="button" (click)="moveBubble(i, 1)" [disabled]="i === draft().bubbles.length - 1" title="เลื่อนลง"
                  class="w-8 h-8 rounded-lg inline-flex items-center justify-center text-slate-400 hover:text-amber-500 disabled:opacity-30 border-none bg-transparent cursor-pointer">
                  <span class="material-icons text-[18px]">arrow_downward</span>
                </button>
                <button type="button" (click)="removeBubble(b.uiKey)" [disabled]="draft().bubbles.length <= 1" title="ลบการ์ด"
                  class="w-8 h-8 rounded-lg inline-flex items-center justify-center text-slate-400 hover:text-rose-500 disabled:opacity-30 border-none bg-transparent cursor-pointer">
                  <span class="material-icons text-[18px]">delete</span>
                </button>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-[180px_minmax(0,1fr)] gap-4">
              <div>
                <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">รูปภาพ (ไม่บังคับ)</label>
                <div class="relative aspect-[20/13] rounded-xl overflow-hidden border border-dashed border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-900 flex items-center justify-center">
                  <img *ngIf="b.imageUrl" [src]="b.imageUrl" alt="" class="w-full h-full object-cover" />
                  <span *ngIf="!b.imageUrl && uploadingKey() !== b.uiKey" class="material-icons text-slate-300 text-3xl">image</span>
                  <span *ngIf="uploadingKey() === b.uiKey" class="absolute inset-0 bg-white/80 dark:bg-slate-900/80 flex items-center justify-center text-xs font-bold text-amber-600">
                    <span class="material-icons animate-spin mr-1 text-[18px]">progress_activity</span>กำลังอัปโหลด
                  </span>
                </div>
                <div *ngIf="isEditable" class="flex gap-2 mt-2">
                  <label class="flex-1 h-8 rounded-lg bg-slate-100 dark:bg-slate-800 text-xs font-bold text-slate-600 dark:text-slate-300 flex items-center justify-center gap-1 cursor-pointer hover:bg-amber-50 hover:text-amber-700">
                    <span class="material-icons text-[16px]">upload</span>
                    {{ b.imageUrl ? 'เปลี่ยนรูป' : 'อัปโหลด' }}
                    <input type="file" accept="image/*" class="hidden" (change)="onBubbleImageSelected(b.uiKey, $event)" />
                  </label>
                  <button *ngIf="b.imageUrl" type="button" (click)="clearBubbleImage(b.uiKey)" title="ลบรูป"
                    class="w-8 h-8 rounded-lg bg-slate-100 dark:bg-slate-800 text-slate-400 hover:text-rose-500 inline-flex items-center justify-center border-none cursor-pointer">
                    <span class="material-icons text-[16px]">close</span>
                  </button>
                </div>
              </div>

              <div class="space-y-3 min-w-0">
                <div>
                  <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">หัวข้อ <span class="text-rose-500">*</span></label>
                  <input [disabled]="!isEditable" [maxlength]="maxBubbleTitle"
                    class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-70"
                    [ngModel]="b.title" (ngModelChange)="patchBubble(b.uiKey, { title: $event })" [ngModelOptions]="{ standalone: true }" />
                </div>
                <div>
                  <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">เนื้อหา</label>
                  <textarea [disabled]="!isEditable" [maxlength]="maxBubbleBody" rows="3"
                    class="w-full px-3 py-2 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200 resize-y disabled:opacity-70"
                    [ngModel]="b.body" (ngModelChange)="patchBubble(b.uiKey, { body: $event })" [ngModelOptions]="{ standalone: true }"></textarea>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-[160px_minmax(0,1fr)] gap-3">
                  <div>
                    <label class="block text-[10px] font-bold text-slate-400 uppercase mb-1">ชื่อปุ่ม</label>
                    <input [disabled]="!isEditable" [maxlength]="maxButtonLabel" placeholder="เช่น ดูรายละเอียด"
                      class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-70"
                      [ngModel]="b.buttonLabel" (ngModelChange)="patchBubble(b.uiKey, { buttonLabel: $event })" [ngModelOptions]="{ standalone: true }" />
                  </div>
                  <div class="min-w-0">
                    <div class="flex items-center justify-between gap-2 mb-1">
                      <label class="text-[10px] font-bold text-slate-400 uppercase">ปลายทางปุ่ม</label>
                      <div class="inline-flex rounded-lg bg-slate-100 dark:bg-slate-800 p-0.5 text-[11px] font-bold">
                        <button type="button" [disabled]="!isEditable" (click)="setBubbleLinkType(b.uiKey, 'liff')"
                          class="px-2.5 h-6 rounded-md border-none cursor-pointer disabled:cursor-default"
                          [ngClass]="b.linkType === 'liff' ? 'bg-white dark:bg-slate-700 text-amber-700 dark:text-amber-400 shadow-sm' : 'bg-transparent text-slate-500'">
                          หน้าใน LIFF
                        </button>
                        <button type="button" [disabled]="!isEditable" (click)="setBubbleLinkType(b.uiKey, 'url')"
                          class="px-2.5 h-6 rounded-md border-none cursor-pointer disabled:cursor-default"
                          [ngClass]="b.linkType === 'url' ? 'bg-white dark:bg-slate-700 text-amber-700 dark:text-amber-400 shadow-sm' : 'bg-transparent text-slate-500'">
                          ลิงก์ภายนอก
                        </button>
                      </div>
                    </div>

                    <ng-container *ngIf="b.linkType === 'liff'; else externalUrl">
                      <div class="flex items-center h-[42px] rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200 overflow-hidden"
                        [class.opacity-70]="!isEditable">
                        <span class="pl-3 pr-1 text-xs text-slate-400 whitespace-nowrap">?redirect=</span>
                        <input [disabled]="!isEditable" placeholder="เช่น ev-charger"
                          class="flex-1 min-w-0 h-full pr-3 bg-transparent outline-none text-sm"
                          [ngModel]="b.liffPath" (ngModelChange)="setBubbleLiffPath(b.uiKey, $event)" [ngModelOptions]="{ standalone: true }" />
                      </div>
                      <div *ngIf="isEditable" class="flex flex-wrap gap-1.5 mt-2">
                        <button *ngFor="let p of liffPages" type="button" (click)="setBubbleLiffPath(b.uiKey, p.path)"
                          class="h-7 px-2.5 rounded-full border text-[11px] font-bold transition-all cursor-pointer bg-transparent"
                          [ngClass]="b.liffPath === p.path
                            ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-300'
                            : 'border-slate-200 dark:border-slate-700 text-slate-500 hover:border-amber-200'">
                          {{ p.label }}
                        </button>
                      </div>
                      <p *ngIf="liffLinkPreview(b)" class="text-[11px] text-slate-400 mt-1 break-all">{{ liffLinkPreview(b) }}</p>
                    </ng-container>
                    <ng-template #externalUrl>
                      <input [disabled]="!isEditable" placeholder="https://..."
                        class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-900 outline-none focus:ring-2 focus:ring-amber-200 disabled:opacity-70"
                        [ngModel]="b.buttonUrl" (ngModelChange)="patchBubble(b.uiKey, { buttonUrl: $event })" [ngModelOptions]="{ standalone: true }" />
                      <p class="text-[11px] text-slate-400 mt-1">เว็บภายนอก (https:// หรือ line://) — หน้าในแอปให้ใช้ “หน้าใน LIFF”</p>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- RIGHT: LINE preview -->
      <aside class="xl:sticky xl:top-6 self-start space-y-4">
        <div class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-5">
          <h3 class="text-sm font-bold text-slate-700 dark:text-slate-200 flex items-center gap-2 mb-3">
            <span class="material-icons text-amber-500 text-[18px]">smartphone</span>
            ตัวอย่างใน LINE
          </h3>

          <div class="rounded-2xl bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700 shadow-sm p-3 flex items-start gap-3 mb-3">
            <span class="w-9 h-9 rounded-xl bg-[#1E242B] text-[#F2A900] inline-flex items-center justify-center shrink-0 font-black text-xs">CP</span>
            <div class="min-w-0">
              <p class="text-xs font-bold text-slate-700 dark:text-slate-200">City Parking</p>
              <p class="text-xs text-slate-500 truncate">
                {{ draft().messageType === 'image'
                  ? (draft().imageText.trim() || 'ส่งรูปภาพ')
                  : (draft().altText || 'ข้อความแจ้งเตือนจะแสดงตรงนี้') }}
              </p>
            </div>
          </div>

          <!-- image mode preview -->
          <div *ngIf="draft().messageType === 'image'" class="line-chat rounded-2xl p-3 pb-4 space-y-2">
            <div *ngFor="let img of draft().images; let first = first; trackBy: trackByImage" class="flex items-end gap-2">
              <span class="w-8 h-8 rounded-full inline-flex items-center justify-center shrink-0 font-black text-[10px]"
                [ngClass]="first ? 'bg-[#1E242B] text-[#F2A900]' : 'invisible'">CP</span>
              <img [src]="img.imageUrl" alt="" class="max-w-[220px] max-h-[260px] rounded-2xl object-cover bg-white shadow-sm" />
            </div>
            <div *ngIf="draft().imageText.trim()" class="flex items-end gap-2">
              <span class="w-8 h-8 rounded-full inline-flex items-center justify-center shrink-0 font-black text-[10px]"
                [ngClass]="draft().images.length ? 'invisible' : 'bg-[#1E242B] text-[#F2A900]'">CP</span>
              <p class="max-w-[240px] rounded-2xl bg-white px-3 py-2 text-[13px] text-[#1E242B] whitespace-pre-line break-words shadow-sm">{{ draft().imageText }}</p>
            </div>
            <p *ngIf="!draft().images.length && !draft().imageText.trim()" class="py-8 text-center text-xs text-slate-500">เพิ่มรูปเพื่อดูตัวอย่าง</p>
          </div>

          <!-- news mode preview -->
          <div *ngIf="draft().messageType === 'news'" class="line-chat rounded-2xl p-3 pb-4">
            <div class="flex items-end gap-2">
              <span class="w-8 h-8 rounded-full bg-[#1E242B] text-[#F2A900] inline-flex items-center justify-center shrink-0 font-black text-[10px]">CP</span>
              <div class="flex gap-2 overflow-x-auto custom-scrollbar pb-2 snap-x snap-mandatory min-w-0">
                <div *ngFor="let n of draft().news; trackBy: trackByNews"
                  class="snap-start shrink-0 w-[240px] rounded-2xl overflow-hidden bg-white shadow-sm" [class.opacity-50]="!n.isAvailable">
                  <img *ngIf="n.coverImageUrl" [src]="n.coverImageUrl" alt="" class="w-full aspect-[20/13] object-cover" />
                  <div class="p-4">
                    <p class="text-[10px] font-bold text-[#F2A900]">{{ n.siteName ? 'ประกาศจากลาน · ' + n.siteName : 'CITY PARKING' }}</p>
                    <p class="text-[15px] font-bold text-[#1E242B] mt-1 break-words line-clamp-3">{{ n.title }}</p>
                    <p *ngIf="n.summary" class="text-xs text-[#4B5563] mt-2 break-words line-clamp-4">{{ n.summary }}</p>
                  </div>
                  <div class="px-4 pb-4">
                    <div class="h-9 rounded-md bg-[#F2A900] text-white text-sm font-bold flex items-center justify-center">อ่านรายละเอียด</div>
                  </div>
                </div>
                <p *ngIf="!draft().news.length" class="py-8 px-4 text-xs text-slate-500">เลือกประกาศเพื่อดูตัวอย่าง</p>
              </div>
            </div>
          </div>

          <div *ngIf="draft().messageType === 'card'" class="line-chat rounded-2xl p-3 pb-4">
            <div class="flex items-end gap-2">
              <span class="w-8 h-8 rounded-full bg-[#1E242B] text-[#F2A900] inline-flex items-center justify-center shrink-0 font-black text-[10px]">CP</span>
              <div class="flex gap-2 overflow-x-auto custom-scrollbar pb-2 snap-x snap-mandatory min-w-0">
                <div *ngFor="let b of draft().bubbles; trackBy: trackByBubble"
                  class="snap-start shrink-0 w-[240px] rounded-2xl overflow-hidden bg-white shadow-sm">
                  <img *ngIf="b.imageUrl" [src]="b.imageUrl" alt="" class="w-full aspect-[20/13] object-cover" />
                  <div class="p-4">
                    <p class="text-[10px] font-bold text-[#F2A900]">CITY PARKING</p>
                    <p class="text-[15px] font-bold text-[#1E242B] mt-1 break-words">{{ b.title || 'หัวข้อการ์ด' }}</p>
                    <p *ngIf="b.body" class="text-xs text-[#4B5563] mt-2 whitespace-pre-line break-words">{{ b.body }}</p>
                  </div>
                  <div *ngIf="b.buttonLabel && (b.linkType === 'liff' ? b.liffPath : b.buttonUrl)" class="px-4 pb-4">
                    <div class="h-9 rounded-md bg-[#F2A900] text-white text-sm font-bold flex items-center justify-center">{{ b.buttonLabel }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="isEditable" class="bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-xl border border-slate-100/50 dark:border-slate-700 p-5 space-y-3">
          <h3 class="text-sm font-bold text-slate-700 dark:text-slate-200 flex items-center gap-2">
            <span class="material-icons text-amber-500 text-[18px]">science</span>
            ส่งทดสอบ
          </h3>
          <p class="text-xs text-slate-400">ส่งเข้า LINE ที่ผูกกับบัญชีของคุณ (เมนูผูกพนักงาน LINE) หรือระบุ LINE userId</p>
          <input [(ngModel)]="testLineUid" placeholder="LINE userId (ไม่บังคับ) เช่น U1234..."
            class="w-full h-[42px] px-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-xs outline-none focus:ring-2 focus:ring-amber-200" />
          <button type="button" (click)="onTestSend()" [disabled]="isSaving() || !!uploadingKey()"
            class="w-full h-[42px] rounded-xl bg-[#06C755] hover:bg-[#05b34c] text-white font-bold text-sm flex items-center justify-center gap-2 disabled:opacity-40 border-none cursor-pointer">
            <span class="material-icons text-[18px]">send_to_mobile</span>
            ส่งทดสอบเข้า LINE
          </button>
        </div>
      </aside>
    </div>
  </ng-container>
</div>

<app-pss-loading *ngIf="isLoading() || isSaving()"></app-pss-loading>

<app-pss-confirm-modal
  *ngIf="isSendConfirmOpen()"
  title="ยืนยันการส่งข้อความ?"
  message="ส่งถึง"
  [highlight]="audienceLabel(draft().audienceType)
    + (draft().audienceType === 'monthly_active' && draft().siteIds.length ? ' (' + draft().siteIds.length + ' site)' : '')
    + ' ' + (selectedAudienceCount ?? 0).toLocaleString() + ' คน'"
  messageSuffix="— ส่งแล้วยกเลิกไม่ได้ และนับโควตา LINE ตามจำนวนผู้รับ"
  confirmLabel="ส่งเลย"
  icon="send"
  variant="warning"
  [loading]="isSaving()"
  (confirm)="confirmSend()"
  (cancel)="closeSendConfirm()">
</app-pss-confirm-modal>

<app-pss-confirm-modal
  *ngIf="isRetryConfirmOpen()"
  title="ส่งซ้ำชุดที่ล้ม?"
  message="ส่งซ้ำให้ผู้รับ"
  [highlight]="(draft().failCount | number) + ' คน'"
  messageSuffix="ที่ส่งไม่สำเร็จ (ผู้ที่ได้รับแล้วจะไม่ได้ซ้ำ)"
  confirmLabel="ส่งซ้ำ"
  icon="replay"
  variant="warning"
  [showIrreversibleNote]="false"
  [loading]="isSaving()"
  (confirm)="confirmRetry()"
  (cancel)="closeRetryConfirm()">
</app-pss-confirm-modal>

<app-pss-confirm-modal
  *ngIf="isDeleteConfirmOpen()"
  title="ยืนยันการลบแคมเปญ?"
  message="ต้องการลบแคมเปญ"
  [highlight]="deleteTarget()?.title || ''"
  messageSuffix="หรือไม่"
  confirmLabel="ลบแคมเปญ"
  icon="delete_forever"
  variant="danger"
  [loading]="isSaving()"
  (confirm)="confirmDelete()"
  (cancel)="closeDeleteConfirm()">
</app-pss-confirm-modal>

<!-- Send progress -->
<div *ngIf="isProgressOpen() && progress() as p"
  class="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-fade-in">
  <div class="w-full max-w-md bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-700 p-6 md:p-8 space-y-5">
    <div class="flex flex-col items-center text-center gap-3">
      <div class="w-16 h-16 rounded-full flex items-center justify-center"
        [ngClass]="!p.isFinished ? 'bg-sky-50 dark:bg-sky-900/30 text-sky-500'
          : p.status === 'sent' ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-500'
          : p.status === 'partial' ? 'bg-amber-50 dark:bg-amber-900/30 text-amber-500'
          : 'bg-rose-50 dark:bg-rose-900/30 text-rose-500'">
        <span class="material-icons text-[34px]" [class.animate-spin]="!p.isFinished">
          {{ !p.isFinished ? 'autorenew' : p.status === 'sent' ? 'check_circle' : p.status === 'partial' ? 'warning' : 'error' }}
        </span>
      </div>
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">
        {{ !p.isFinished ? 'กำลังส่งข้อความ LINE...' : p.status === 'sent' ? 'ส่งครบแล้ว' : p.status === 'partial' ? 'ส่งเสร็จ — มีบางส่วนไม่สำเร็จ' : 'ส่งไม่สำเร็จ' }}
      </h3>
    </div>

    <div class="space-y-2">
      <div class="flex items-end justify-between">
        <span class="text-xs font-bold text-slate-400 uppercase">ความคืบหน้า</span>
        <span class="text-3xl font-black text-slate-800 dark:text-slate-100 tabular-nums">{{ p.percent }}%</span>
      </div>
      <div class="h-3 rounded-full bg-slate-100 dark:bg-slate-800 overflow-hidden">
        <div class="h-full rounded-full transition-all duration-500"
          [ngClass]="!p.isFinished ? 'bg-gradient-to-r from-sky-500 to-amber-400' : p.status === 'sent' ? 'bg-emerald-500' : p.status === 'partial' ? 'bg-amber-500' : 'bg-rose-500'"
          [style.width.%]="p.percent"></div>
      </div>
      <p class="text-xs text-slate-500 tabular-nums text-center">
        {{ p.processedCount | number }} / {{ p.recipientCount | number }} คน · ชุด {{ p.batchDone }}/{{ p.batchTotal }}
      </p>
    </div>

    <div class="grid grid-cols-2 gap-3">
      <div class="rounded-2xl bg-emerald-50 dark:bg-emerald-900/20 p-3 text-center">
        <p class="text-[11px] font-bold text-emerald-600 uppercase">สำเร็จ</p>
        <p class="text-xl font-black text-emerald-700 dark:text-emerald-400 tabular-nums">{{ p.successCount | number }}</p>
      </div>
      <div class="rounded-2xl bg-rose-50 dark:bg-rose-900/20 p-3 text-center">
        <p class="text-[11px] font-bold text-rose-500 uppercase">ไม่สำเร็จ</p>
        <p class="text-xl font-black text-rose-600 dark:text-rose-400 tabular-nums">{{ p.failCount | number }}</p>
      </div>
    </div>

    <p *ngIf="p.isFinished && p.errorMessage" class="text-xs text-rose-600 dark:text-rose-400 text-center">{{ p.errorMessage }}</p>
    <p *ngIf="!p.isFinished" class="text-[11px] text-slate-400 text-center">ปิดหน้าต่างนี้ได้ — ระบบยังส่งต่อเบื้องหลัง</p>

    <button type="button" (click)="closeProgress()"
      class="w-full py-3 rounded-2xl font-bold text-sm transition-all"
      [ngClass]="p.isFinished ? 'bg-amber-500 hover:bg-amber-600 text-white shadow-lg shadow-amber-500/30' : 'bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-300'">
      {{ p.isFinished ? 'ปิด' : 'ซ่อน (ส่งต่อเบื้องหลัง)' }}
    </button>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory"
  [entityType]="activityEntityTypes.LineBroadcast"
  [entityId]="draft().id"
  [subtitle]="draft().title"
  (close)="showActivityHistory = false">
</app-modal-admin-activity-history>

<!-- Monthly members detail (layer 1: people) -->
<div *ngIf="showMonthlyDetail()"
  class="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-fade-in"
  (click)="closeMonthlyDetail()">
  <div class="w-full max-w-3xl max-h-[88vh] flex flex-col bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-700"
    (click)="$event.stopPropagation()">
    <div class="px-6 pt-6 pb-4 flex items-start justify-between gap-3 border-b border-slate-100 dark:border-slate-800">
      <div class="min-w-0">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">card_membership</span>
          สมาชิกรายเดือนที่ใช้งานอยู่
        </h3>
        <p class="text-xs text-slate-400 mt-0.5 truncate">
          site: {{ isEditable ? (navSiteName || '—') : (draft().siteNames.join(', ') || 'ทุก site') }}
          · บัตรเสียเงินที่ยังไม่หมดอายุ · ทั้งหมด <b class="text-slate-600 dark:text-slate-300 tabular-nums">{{ detailTotal() | number }}</b> คน
        </p>
      </div>
      <button type="button" (click)="closeMonthlyDetail()"
        class="w-9 h-9 rounded-xl inline-flex items-center justify-center text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 shrink-0">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="px-6 py-3">
      <div class="relative">
        <span class="material-icons absolute left-3 top-1/2 -translate-y-1/2 text-[18px] text-slate-400">search</span>
        <input [(ngModel)]="detailSearch" [ngModelOptions]="{ standalone: true }" (keyup.enter)="onDetailSearch()"
          placeholder="ค้นหาชื่อ / เบอร์โทร แล้วกด Enter"
          class="w-full h-10 pl-10 pr-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm outline-none focus:ring-2 focus:ring-amber-200" />
      </div>
    </div>

    <div class="flex-1 overflow-y-auto custom-scrollbar px-6 relative min-h-[160px]">
      <div *ngIf="isDetailLoading()" class="absolute inset-0 z-10 flex items-center justify-center bg-white/60 dark:bg-slate-900/60">
        <span class="material-icons animate-spin text-amber-500">autorenew</span>
      </div>
      <div class="divide-y divide-slate-50 dark:divide-slate-800">
        <button *ngFor="let m of detailMembers()" type="button" (click)="openMemberCards(m)"
          class="w-full py-3 flex items-center gap-3 text-left hover:bg-amber-50/50 dark:hover:bg-amber-900/10 rounded-xl px-2 transition-colors cursor-pointer">
          <span class="w-9 h-9 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 inline-flex items-center justify-center shrink-0">
            <span class="material-icons text-[20px]">person</span>
          </span>
          <span class="min-w-0 flex-1">
            <span class="flex items-center gap-2">
              <span class="font-semibold text-slate-700 dark:text-slate-200 truncate">{{ m.name }}</span>
              <span *ngIf="isExcluded(m.cpUserId)" class="px-1.5 rounded bg-rose-50 dark:bg-rose-950/30 text-rose-500 text-[10px] font-bold shrink-0">ติ๊กออก</span>
            </span>
            <span class="flex flex-wrap gap-1 mt-1">
              <span *ngFor="let s of m.subscriptionNames"
                class="px-2 py-0.5 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 text-[11px] font-semibold">{{ s }}</span>
              <span *ngIf="!m.subscriptionNames.length" class="text-[11px] text-slate-400">—</span>
            </span>
          </span>
          <span class="text-right shrink-0">
            <span class="block text-sm font-black text-slate-800 dark:text-slate-100 tabular-nums">{{ m.cardCount | number }} ใบ</span>
            <span class="block text-[10px] text-slate-400 tabular-nums">{{ m.phone || '—' }}</span>
          </span>
          <span class="material-icons text-slate-300">chevron_right</span>
        </button>
        <p *ngIf="!detailMembers().length && !isDetailLoading()" class="py-10 text-center text-xs text-slate-400">ไม่พบสมาชิกรายเดือนที่ใช้งานอยู่</p>
      </div>
    </div>

    <div class="px-6 py-4 flex items-center justify-between text-xs text-slate-500 border-t border-slate-100 dark:border-slate-800">
      <span class="tabular-nums">หน้า {{ detailPage() }}/{{ detailTotalPages }}</span>
      <div class="flex items-center gap-1">
        <button type="button" (click)="onDetailPageChange(detailPage() - 1)" [disabled]="detailPage() <= 1"
          class="w-8 h-8 rounded-lg inline-flex items-center justify-center hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-40">
          <span class="material-icons text-[18px]">chevron_left</span>
        </button>
        <button type="button" (click)="onDetailPageChange(detailPage() + 1)" [disabled]="detailPage() >= detailTotalPages"
          class="w-8 h-8 rounded-lg inline-flex items-center justify-center hover:bg-slate-100 dark:hover:bg-slate-800 disabled:opacity-40">
          <span class="material-icons text-[18px]">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Monthly members detail (layer 2: cards of one member) -->
<div *ngIf="memberCards() as mc"
  class="fixed inset-0 z-[1010] flex items-center justify-center p-4 bg-slate-900/40 animate-fade-in"
  (click)="closeMemberCards()">
  <div class="w-full max-w-2xl max-h-[85vh] flex flex-col bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-700"
    (click)="$event.stopPropagation()">
    <div class="px-6 pt-6 pb-4 flex items-start justify-between gap-3 border-b border-slate-100 dark:border-slate-800">
      <div class="min-w-0">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 truncate">{{ mc.name }}</h3>
        <p class="text-xs text-slate-400 mt-0.5 tabular-nums">{{ mc.phone || '—' }}</p>
        <p *ngIf="mc.lineId" class="text-[11px] text-slate-400 mt-0.5 font-mono truncate" [title]="mc.lineId">LINE UID: {{ mc.lineId }}</p>
      </div>
      <button type="button" (click)="closeMemberCards()"
        class="w-9 h-9 rounded-xl inline-flex items-center justify-center text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 shrink-0">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto custom-scrollbar p-6 space-y-3 relative min-h-[140px]">
      <div *ngIf="isMemberCardsLoading()" class="absolute inset-0 z-10 flex items-center justify-center bg-white/60 dark:bg-slate-900/60">
        <span class="material-icons animate-spin text-amber-500">autorenew</span>
      </div>
      <div *ngFor="let c of mc.items" class="rounded-2xl border border-slate-100 dark:border-slate-700 p-4 space-y-2">
        <div class="flex items-start justify-between gap-3">
          <div class="min-w-0">
            <p class="font-bold text-slate-700 dark:text-slate-200 truncate">{{ c.subscriptionName || '—' }}</p>
            <p class="text-xs text-slate-400 truncate">{{ c.siteName || '—' }}</p>
          </div>
          <span class="px-2 py-0.5 rounded-full bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 text-[11px] font-bold shrink-0">ใช้งานอยู่</span>
        </div>
        <div class="grid grid-cols-2 gap-x-4 gap-y-1 text-xs">
          <span class="text-slate-400">เลขบัตร</span>
          <span class="text-slate-700 dark:text-slate-200 font-semibold tabular-nums truncate">{{ c.cardCode || '—' }}</span>
          <span class="text-slate-400">ชื่อบนบัตร</span>
          <span class="text-slate-700 dark:text-slate-200 truncate">{{ c.holderName || c.cardName || '—' }}</span>
          <span class="text-slate-400">ทะเบียนรถ</span>
          <span class="text-slate-700 dark:text-slate-200 truncate">{{ c.licenses.length ? c.licenses.join(', ') : '—' }}</span>
          <span class="text-slate-400">ช่วงใช้งาน</span>
          <span class="text-slate-700 dark:text-slate-200 tabular-nums">
            {{ c.issueDate ? (c.issueDate | date:'dd/MM/yyyy') : '—' }} – {{ c.expireDate ? (c.expireDate | date:'dd/MM/yyyy') : '—' }}
          </span>
        </div>
      </div>
      <p *ngIf="!mc.items.length && !isMemberCardsLoading()" class="py-8 text-center text-xs text-slate-400">ไม่พบบัตรรายเดือนที่ใช้งานอยู่</p>
    </div>
  </div>
</div>
